module.exports = __webpack_public_path__ + "static/media/landing-3.ee1b391e.png";